import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopicFilterPipe } from './topic-filter.pipe';
import { InfoCategoryFilterPipe } from './info-category-filter.pipe';
import { MediaFileCachePipe } from './media-file-cache.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';


@NgModule({
  declarations: [TopicFilterPipe, InfoCategoryFilterPipe, MediaFileCachePipe, SafeHtmlPipe],
  imports: [
    CommonModule
  ],
  exports: [TopicFilterPipe, InfoCategoryFilterPipe, MediaFileCachePipe, SafeHtmlPipe]
})
export class PipesModule {
}
